import _flatten from 'lodash/flatten'
import _countBy from 'lodash/countBy'
import _uniq from 'lodash/uniq'
import _sortBy from 'lodash/sortBy'

export function fromDomains (a) {
  if (!a) {
    return a
  }

  const content = []
  const domains = Array.isArray(a) ? a : []

  domains.forEach(domain => {
    // For domains column, only show parent domains (those with parentId: null)
    if (domain.parentId === null) {
      const label = domain.name
      if (label && !content.includes(label)) {
        content.push(label)
      }
    }
  })

  return content.join(',\n')
}

export function fromSubdomains (a) {
  if (!a) {
    return a
  }

  const content = []
  const domains = Array.isArray(a) ? a : []

  domains.forEach(domain => {
    // For subdomains column, only show child domains (those with parentId: not null)
    if (domain.parentId !== null) {
      const label = domain.name
      if (label && !content.includes(label)) {
        content.push(label)
      }
    }
  })

  return content.join(',\n')
}

export function fromDomain (a) {
  // Handle different data types - could be object with name/label or just a string
  if (typeof a === 'string') {
    return a
  }
  return a.name || a.label || a
}

export function toDomains (a) {
  return a && a.split ? a.split(/,+/).map(s => s.trim()) : a
}

export function toSubdomains (a) {
  return a && a.split ? a.split(/,+/).map(s => s.trim()) : a
}

export function DomainsEditor () {
  const editor = Handsontable.editors.TextEditor.prototype.extend()

  editor.prototype.getValue = function () {
    return fromDomains(toDomains(this.TEXTAREA.value))
  }

  editor.prototype.setValue = function (newValue) {
    this.TEXTAREA.value = fromDomains(toDomains(newValue))
  }

  return editor
}

export function SubdomainsEditor () {
  const editor = Handsontable.editors.TextEditor.prototype.extend()

  editor.prototype.getValue = function () {
    return fromSubdomains(toSubdomains(this.TEXTAREA.value))
  }

  editor.prototype.setValue = function (newValue) {
    this.TEXTAREA.value = fromSubdomains(toSubdomains(newValue))
  }

  return editor
}

export function DomainsRenderer (instance, TD, row, col, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, [instance, TD, row, col, prop, fromDomains(value), cellProperties])
}

export function SubdomainsRenderer (instance, TD, row, col, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, [instance, TD, row, col, prop, fromSubdomains(value), cellProperties])
}

export function getDomainsMenu (actors) {
  // Relation removal items
  const existing = _flatten(actors.map(a => a['_domains'] || []))
  const counts = _countBy(existing, 'name')
  const unique = _uniq(existing)

  // Create copies to avoid mutating store state
  const uniqueWithCounts = unique.map(item => ({
    ...item,
    count: counts[item.to],
  }))

  const sorted = _sortBy(uniqueWithCounts, 'count').reverse()

  const menu = {}

  for (let i = 0; i < sorted.length; i++) {
    // Use domain name as identifier since id is null
    const domainName = sorted[i].name
    menu['REMOVE_DOMAIN_NAME_' + domainName] = 'Remove ' + domainName
  }

  return menu
}

export function getSubdomainsMenu (actors) {
  // Relation removal items for subdomains
  const existing = _flatten(actors.map(a => a['_subdomains'] || []))
  const counts = _countBy(existing, 'name')
  const unique = _uniq(existing)

  // Create copies to avoid mutating store state
  const uniqueWithCounts = unique.map(item => ({
    ...item,
    count: counts[item.to],
  }))

  const sorted = _sortBy(uniqueWithCounts, 'count').reverse()

  const menu = {}

  for (let i = 0; i < sorted.length; i++) {
    // Use domain name as identifier since id is null
    const domainName = sorted[i].name
    menu['REMOVE_SUBDOMAIN_NAME_' + domainName] = 'Remove ' + domainName
  }

  return menu
}
